var map = {
	"./Assortments.vue": "be65",
	"./EditClient copy.vue": "1888",
	"./EditClient.vue": "867e",
	"./components/FieldBlock.vue": "b42d",
	"./components/assortments/assortment-list.vue": "b056",
	"./components/edit-client/BonusAccount.vue": "ef2c",
	"./components/edit-client/CardAccount.vue": "a367",
	"./components/edit-client/EditPhone.vue": "d39f",
	"./components/edit-client/ModeExtended.vue": "71ae",
	"./components/edit-client/ModeUsual.vue": "aa30",
	"./components/edit-client/OwnerAccount.vue": "6614",
	"./components/edit-client/SaleAccount.vue": "2114",
	"./components/edit-client/tabs/TabClient.vue": "3af8",
	"./components/edit-client/tabs/TabDocument.vue": "2966",
	"./components/edit-client/tabs/TabFields.vue": "eedc",
	"./components/edit-client/tabs/TabMap.vue": "9234",
	"./components/edit-client/tabs/TabOperation.vue": "1b43",
	"./components/edit-client/tabs/TabReferral.vue": "65f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f72";